import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "components/common";
import Routes from "routing/Routes";
import AppConfig from "util/AppConfig";
const isCloud = AppConfig.isCloud();
const ArchivePageHeaderDescription = () => {
  const { t } = useTranslation("enterprise_archive");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", null, t("archive_page_header_description.intro"), " "), isCloud ? /* @__PURE__ */ React.createElement("span", null, t("archive_page_header_description.cloud_hint")) : /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "archive_page_header_description.indices_hint",
      components: { indicesLink: /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.INDICES.LIST }) }
    }
  )));
};
export default ArchivePageHeaderDescription;
